import {
  cleanUpInventorySheetList,
  defaultPagination,
  setInventorySheetListPagination,
} from "../../../reducers/inventorySheetReducer";
import { AppDispatch } from "../../../store";

export const resetInventorySheet = (dispatch: AppDispatch): void => {
  dispatch(cleanUpInventorySheetList());
  dispatch(setInventorySheetListPagination(defaultPagination));
};
